import styled from 'styled-components';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { mediaQuery } from 'components';

export const ProductTabsWrapper = styled(Tabs)`
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
`;

export const ProductTabList = styled(TabList)`
  list-style-type: none;
  padding: 4px;
  display: flex;
  margin: 2rem 0;
  justify-content: center;
`;
export const ProductTab = styled(Tab)`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;

  margin-right: 0rem;
  margin-bottom: 1rem;
  font-size: 1rem;
  text-align: center;
  user-select: none;
  cursor: pointer;
  color: #a3a3a3;
  position: relative;

  &.is-selected {
    color: #333;
  }

  ${mediaQuery.small`
    font-size: 1rem;
    margin-bottom: 0;
    margin-right: 2rem;
  `}
  ${mediaQuery.medium`
    &.is-selected:after {
      content: "";
      position: absolute;
      top: 100%;
      width: 100%;
      height: 1px;
      background: #000;
      left: 0;
    }
  }`}
`;

export const ProductTabPanel = styled(TabPanel)`
  display: none;
  text-align: center;
  padding-left: 1rem;
  padding-right: 1rem;
  min-height: 20rem;

  ${mediaQuery.small`
    padding-left: 0;
    padding-right: 0;
  `}
  &.is-selected {
    display: block;
  }

  &.is-selected > div {
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: 2rem;
  }

  a {
    font-size: 0.8rem;
  }

  img {
    max-width: 100%;
  }
`;

export const MobileProductTabListWrapper = styled.div<{ isFocused: boolean }>`
  list-style: none;
  position: relative;
  width: 100%;
  display: block;
  height: 2rem;
  margin: 2rem 0;
  li:not(.is-selected) {
    display: ${props => (props.isFocused ? 'block' : 'none')};
    margin-right: 0;
  }
  li.is-selected {
    position: relative;
  }
  li.is-selected:after {
    content: "";
    display: ${props => (props.isFocused ? 'none' : 'block')};
    position: absolute;
    left: 120%;
    top: 50%;
    width: 0;
    transform: translateY(-50%);
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #000;
  }
  ul {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 0.25rem 0.5rem;
    text-align: center;
    background: ${props => (props.isFocused ? 'white' : 'transparent')};
    border: ${props => (props.isFocused ? '1px solid black' : '0')};
    z-index: 10;
  }
`;

export const MobileProductTabList = styled(TabList)`
  border: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  li {
    border-bottom: 0;
  }
`;
